export const extractErrors = ({ inner }) => {
    return inner.reduce((acc, err) => {
        return { ...acc, [err.path]: err.message };
    }, {});
};

export const validateForm = async (schema, values) => {
    return await schema
        .validate(values, { abortEarly: false })
        .then(() => { return true })
        .catch(() => { return false });
}